import { getEffectivePlan } from "../../platform/util/utils";
import { hasStandaloneBookingAccess } from "./productAccess";

export const BUSINESS_VISIBILITY_MIN_PLAN = 2;

export function getDirectoryToggleVisibility({
  productId,
  hasCareAccess = false,
  isHealthcareCategorySelected = false,
}: {
  productId?: string | null;
  hasCareAccess?: boolean;
  isHealthcareCategorySelected?: boolean;
}) {
  return {
    showCareDirectoryToggle:
      productId === "care" && hasCareAccess && isHealthcareCategorySelected,
    showBookingDirectoryToggle: productId === "booking",
  };
}

export function hasBusinessVisibilityTrialAccess(
  providerUser: any,
  minPlan: number = BUSINESS_VISIBILITY_MIN_PLAN
): boolean {
  return Number(getEffectivePlan(providerUser) || 0) >= minPlan;
}

export function canUseBookingDirectoryVisibility({
  providerUser,
  isCareBusiness = null,
  hasBookingBillingAccess = false,
  minPlan = BUSINESS_VISIBILITY_MIN_PLAN,
}: {
  providerUser: any;
  isCareBusiness?: boolean | null;
  hasBookingBillingAccess?: boolean;
  minPlan?: number;
}): boolean {
  return (
    hasStandaloneBookingAccess(providerUser, isCareBusiness) ||
    hasBookingBillingAccess ||
    hasBusinessVisibilityTrialAccess(providerUser, minPlan)
  );
}

export function shouldRequireBusinessVisibilityUpgrade({
  productId,
  checked,
  providerUser,
  isCareBusiness = null,
  hasBookingBillingAccess = false,
  minPlan = BUSINESS_VISIBILITY_MIN_PLAN,
}: {
  productId?: string | null;
  checked: boolean;
  providerUser: any;
  isCareBusiness?: boolean | null;
  hasBookingBillingAccess?: boolean;
  minPlan?: number;
}): boolean {
  if (!checked) return false;

  if (productId !== "booking") {
    return !hasBusinessVisibilityTrialAccess(providerUser, minPlan);
  }

  return !canUseBookingDirectoryVisibility({
    providerUser,
    isCareBusiness,
    hasBookingBillingAccess,
    minPlan,
  });
}
